import type { InferredEntity } from '@sites/entity-migrator';
import { createVersionedEntityWithDefaults } from '@sites/entity-migrator';

import { indentDefaultV0Schema } from './v0';
import { indentLegacyShapeSchema } from '../legacy/shape';
import { migrateLegacyIndentToV0 } from '../legacy/migration';

export const DefaultIndentEntitySchema = createVersionedEntityWithDefaults({
    versionMap: {
        0: { schema: indentDefaultV0Schema },
    },
    latestVersion: 0,
    legacy: [{ name: 'web', schema: indentLegacyShapeSchema, up: migrateLegacyIndentToV0 }],
});

export type DefaultIndent = InferredEntity<typeof DefaultIndentEntitySchema>;
